export const Permission = {
  ViewInvoice: "vt_web_view_invoice_trade",
  ViewTrade: "vt_web_view_individual_trade",
} as const
